import React from 'react';
import PropTypes from 'prop-types';
import {Tabs, Tab} from './Tabs';
import {Content} from './Content';
import {Header} from '../../../Header';
import cname from '../style.module.scss';
import {Modal, Button} from '@learningblocks/shared-components';
import {INFO_TABS} from '../Spectrophotometer.utils';
import './style.scss';

/**
 * SpectrophotometerInfoModal:
 *  - Give user general info on Spectrophotometer and
 *    its working
 */
export function SpectrophotometerInfoModal(props) {
  const [tabs, updateTabs] = React.useState(INFO_TABS);

  const setTabCurrent = (label) => {
    const mapTabs = (tab) => {
      if (tab.label === label) return {...tab, current: true};
      else return {...tab, current: false};
    };
    updateTabs((tabs) => tabs.map(mapTabs));
  };

  const renderTab = (tab) => (
    <Tab
      key={tab.label}
      label={tab.label}
      current={tab.current}
      onClick={setTabCurrent}
    />
  );

  const currentType = React.useMemo(
    () => tabs.find((tab) => tab.current).label,
    [tabs]
  );

  return (
    <Modal
      isOpen={props.isOpen}
      className={`${cname.infoModal} spectrophotometer_infoModal`}
      closeButton={true}
      notebookExpanded={!props.notebookCollapsed}
      close={props.onClose}>
      <Header
        className={cname.header}
        label='SPECTROPHOTOMETER INFO'
        size={props.size}
      />
      <div className={cname.section}>
        <Tabs>{tabs.map(renderTab)}</Tabs>
        <Content type={currentType} />
      </div>
      <div className={cname.footer}>
        <Button onClick={props.onClose}>Done</Button>
      </div>
    </Modal>
  );
}

SpectrophotometerInfoModal.propTypes = {
  /**
   * Boolen to set if popup is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback to close Modal window
   */
  onClose: PropTypes.func,
};

SpectrophotometerInfoModal.defaultProps = {
  isOpen: false,
  size: 'lg',
};
